<style lang="scss">
  @import '../resources/scss/header.scss';
</style>

<script lang="ts">
  import LocaleSwitcher from './LocaleSwitcher.svelte'
  import MediaQuery from './MediaQuery.svelte'
  import NavLink from './NavLink.svelte'
  import { Constants } from '../config/constants'
  import { ScreenSizes } from '../config/screen_sizes'
  import { menus, routes, isMenuOpen } from '../stores/stores'
  import logoDecoded from '../resources/assets/logo.svg'
  import logoSmDecoded from '../resources/assets/logo_sm.svg'
  import MenuItem from './MenuItem.svelte'
  import { Slugs } from '../config/slugs'
  import MenuMobile from './Menu_Mobile.svelte'
  import HeaderSearch from './Header_Search.svelte'
  import { setMenuOpen } from '../helpers/MenuHelper'

  export let lang: string

  let a = $menus.filter(m => m.menu_type === 'header')
  let menus_right = $menus.filter(m => m.menu_type === 'header_right')
  let menu_profile = $menus.find(m => m.slug === Slugs.Profile)

  function handleResize() {
    if (window.innerWidth > ScreenSizes.MD_MAX_WIDTH) {
      document.querySelector('.main-content-container')?.classList.remove('d-none')
      document.querySelector('.footer')?.classList.remove('d-none')
      document.querySelector('.navbar.header')?.classList.remove('position-fixed')
      document.querySelector('.navbar.header')?.classList.remove('w-100')
      document.querySelector('.navbar.header')?.classList.add('position-static')
      $isMenuOpen = false
    }
  }
  window.addEventListener('resize', handleResize)
</script>

<header class="sticky-top">
  <nav class="navbar header navbar-expand-lg navbar-light bg-white p-0">
    <div class="container-xxl h-100">
      <MediaQuery query="(max-width: {ScreenSizes.SM_MIN_WIDTH}px)" let:matches>
        {#if matches}
          <a class="navbar-brand logo" href="/">{@html logoSmDecoded}</a>
        {:else}
          <a class="navbar-brand row logo" href="/">{@html logoDecoded}</a>
        {/if}
      </MediaQuery>
      <MediaQuery query="(max-width: {ScreenSizes.MD_MAX_WIDTH}px)" let:matches>
        <button
          class="navbar-toggler"
          class:change={$isMenuOpen}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          on:click={() => setMenuOpen($isMenuOpen, matches, true)}
        />
        {#if matches}
          <div class="order-3 icon-profile">
            {#if menu_profile}
              <NavLink
                ref={$routes.get(`${lang}${Constants.DOUBLE_BARS}${Slugs.Profile}`)}
                name="LOGIN"
                external={true}
                isIcon={false}
              />
            {/if}
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <MenuMobile {lang} />
          </div>
        {:else}
          <div class="row flex-grow-1 h-100">
            <div class="col-12 col-lg-6 col-xl-8">
              <ul class="navbar-nav mb-2 mb-lg-0 justify-content-center h-100">
                {#each a as menu}
                  <MenuItem
                    {menu}
                    {lang}
                    homepage={menu.slug === Slugs.About}
                    main={true}
                  />
                {/each}
              </ul>
            </div>
            <div
              class="col-3 col-lg-6 col-xl-4 d-flex flex-column justify-content-around"
            >
              <HeaderSearch />
              <ul class="navbar-nav mb-2 mb-lg-0 d-flex justify-content-between flex-row">
                {#each menus_right as menu}
                  <MenuItem {menu} {lang} />
                {/each}
                <LocaleSwitcher />
              </ul>
            </div>
          </div>
        {/if}
      </MediaQuery>
    </div>
  </nav>
</header>
